import MultipleButtonModal from './MultipleButtonModal';

export default MultipleButtonModal;
